// AUTO-GENERATED (do not hand-edit) from the University of Michigan EGX "Ann Arbor"
// Plan B directional survey (R_o-k validation set). A near-U-turn HORSESHOE:
// vertical -> build (KOP ~4,100 ft) -> ~110 deg azimuth turn (350->240) at
// horizontal -> lateral. Values copied VERBATIM (welleng-computed in R_o-k);
// md/tvd/northing/easting converted ft->m for the SI-metre survey store; inc/azi
// in degrees. Embedded here because the front end cannot read the Python fixture
// at runtime. Drives the subway schematic's fold-back rendering on the Permian
// Horizontal Pad (well PH-11H).
import type { SurveyPoint } from "../features/borefields/types";

/** 129 stations, MD 0 -> 3657.6 m (~12,000 ft), TVD 0 -> 1425.43 m (~4,677 ft), azimuth 350 -> 240 deg. */
export const ANN_ARBOR_HORSESHOE_SURVEY_M: SurveyPoint[] = [
  { md: 0, inc: 0, azi: 350, tvd: 0, northing: 0, easting: 0 },
  { md: 30.48, inc: 0, azi: 350, tvd: 30.48, northing: 0, easting: 0 },
  { md: 60.96, inc: 0, azi: 350, tvd: 60.96, northing: 0, easting: 0 },
  { md: 91.44, inc: 0, azi: 350, tvd: 91.44, northing: 0, easting: 0 },
  { md: 121.92, inc: 0, azi: 350, tvd: 121.92, northing: 0, easting: 0 },
  { md: 152.4, inc: 0, azi: 350, tvd: 152.4, northing: 0, easting: 0 },
  { md: 182.88, inc: 0, azi: 350, tvd: 182.88, northing: 0, easting: 0 },
  { md: 213.36, inc: 0, azi: 350, tvd: 213.36, northing: 0, easting: 0 },
  { md: 243.84, inc: 0, azi: 350, tvd: 243.84, northing: 0, easting: 0 },
  { md: 274.32, inc: 0, azi: 350, tvd: 274.32, northing: 0, easting: 0 },
  { md: 304.8, inc: 0, azi: 350, tvd: 304.8, northing: 0, easting: 0 },
  { md: 335.28, inc: 0, azi: 350, tvd: 335.28, northing: 0, easting: 0 },
  { md: 365.76, inc: 0, azi: 350, tvd: 365.76, northing: 0, easting: 0 },
  { md: 396.24, inc: 0, azi: 350, tvd: 396.24, northing: 0, easting: 0 },
  { md: 426.72, inc: 0, azi: 350, tvd: 426.72, northing: 0, easting: 0 },
  { md: 457.2, inc: 0, azi: 350, tvd: 457.2, northing: 0, easting: 0 },
  { md: 487.68, inc: 0, azi: 350, tvd: 487.68, northing: 0, easting: 0 },
  { md: 518.16, inc: 0, azi: 350, tvd: 518.16, northing: 0, easting: 0 },
  { md: 548.64, inc: 0, azi: 350, tvd: 548.64, northing: 0, easting: 0 },
  { md: 579.12, inc: 0, azi: 350, tvd: 579.12, northing: 0, easting: 0 },
  { md: 609.6, inc: 0, azi: 350, tvd: 609.6, northing: 0, easting: 0 },
  { md: 640.08, inc: 0, azi: 350, tvd: 640.08, northing: 0, easting: 0 },
  { md: 670.56, inc: 0, azi: 350, tvd: 670.56, northing: 0, easting: 0 },
  { md: 701.04, inc: 0, azi: 350, tvd: 701.04, northing: 0, easting: 0 },
  { md: 731.52, inc: 0, azi: 350, tvd: 731.52, northing: 0, easting: 0 },
  { md: 762, inc: 0, azi: 350, tvd: 762, northing: 0, easting: 0 },
  { md: 792.48, inc: 0, azi: 350, tvd: 792.48, northing: 0, easting: 0 },
  { md: 822.96, inc: 0, azi: 350, tvd: 822.96, northing: 0, easting: 0 },
  { md: 853.44, inc: 0, azi: 350, tvd: 853.44, northing: 0, easting: 0 },
  { md: 883.92, inc: 0, azi: 350, tvd: 883.92, northing: 0, easting: 0 },
  { md: 914.4, inc: 0, azi: 350, tvd: 914.4, northing: 0, easting: 0 },
  { md: 944.88, inc: 0, azi: 350, tvd: 944.88, northing: 0, easting: 0 },
  { md: 975.36, inc: 0, azi: 350, tvd: 975.36, northing: 0, easting: 0 },
  { md: 1005.84, inc: 0, azi: 350, tvd: 1005.84, northing: 0, easting: 0 },
  { md: 1036.32, inc: 0, azi: 350, tvd: 1036.32, northing: 0, easting: 0 },
  { md: 1066.8, inc: 0, azi: 350, tvd: 1066.8, northing: 0, easting: 0 },
  { md: 1097.28, inc: 0, azi: 350, tvd: 1097.28, northing: 0, easting: 0 },
  { md: 1127.76, inc: 0, azi: 350, tvd: 1127.76, northing: 0, easting: 0 },
  { md: 1158.24, inc: 0, azi: 350, tvd: 1158.24, northing: 0, easting: 0 },
  { md: 1188.72, inc: 0, azi: 350, tvd: 1188.72, northing: 0, easting: 0 },
  { md: 1219.2, inc: 0, azi: 350, tvd: 1219.2, northing: 0, easting: 0 },
  { md: 1231.39, inc: 0, azi: 350, tvd: 1231.39, northing: 0, easting: 0 },
  {
    md: 1249.68,
    inc: 5.4,
    azi: 350,
    tvd: 1249.65,
    northing: 0.55,
    easting: 0.85,
  },
  {
    md: 1280.16,
    inc: 14.4,
    azi: 350,
    tvd: 1279.65,
    northing: 3.92,
    easting: 6,
  },
  {
    md: 1310.64,
    inc: 23.4,
    azi: 350,
    tvd: 1308.45,
    northing: 10.25,
    easting: 15.72,
  },
  {
    md: 1332.99,
    inc: 30,
    azi: 350,
    tvd: 1328.41,
    northing: 16.7,
    easting: 25.6,
  },
  {
    md: 1341.12,
    inc: 32.4,
    azi: 350,
    tvd: 1335.37,
    northing: 19.4,
    easting: 29.75,
  },
  {
    md: 1371.6,
    inc: 41.4,
    azi: 350,
    tvd: 1359.71,
    northing: 31.15,
    easting: 47.75,
  },
  {
    md: 1402.08,
    inc: 50.4,
    azi: 350,
    tvd: 1380.9,
    northing: 45.19,
    easting: 69.29,
  },
  {
    md: 1432.56,
    inc: 59.4,
    azi: 350,
    tvd: 1398.41,
    northing: 61.19,
    easting: 93.82,
  },
  {
    md: 1434.59,
    inc: 60,
    azi: 350,
    tvd: 1399.44,
    northing: 62.32,
    easting: 95.55,
  },
  {
    md: 1463.04,
    inc: 68.4,
    azi: 350,
    tvd: 1411.81,
    northing: 78.76,
    easting: 120.75,
  },
  {
    md: 1493.52,
    inc: 77.4,
    azi: 350,
    tvd: 1420.76,
    northing: 97.45,
    easting: 149.41,
  },
  {
    md: 1524,
    inc: 86.4,
    azi: 350,
    tvd: 1425.05,
    northing: 116.81,
    easting: 179.09,
  },
  {
    md: 1536.19,
    inc: 90,
    azi: 350,
    tvd: 1425.43,
    northing: 125.21,
    easting: 191.09,
  },
  {
    md: 1554.48,
    inc: 90,
    azi: 350,
    tvd: 1425.43,
    northing: 136.39,
    easting: 209.1,
  },
  {
    md: 1584.96,
    inc: 90,
    azi: 350,
    tvd: 1425.43,
    northing: 155.97,
    easting: 239.12,
  },
  {
    md: 1615.44,
    inc: 90,
    azi: 350,
    tvd: 1425.43,
    northing: 175.55,
    easting: 269.14,
  },
  {
    md: 1645.92,
    inc: 90,
    azi: 350,
    tvd: 1425.43,
    northing: 195.12,
    easting: 299.16,
  },
  {
    md: 1676.4,
    inc: 90,
    azi: 350,
    tvd: 1425.43,
    northing: 214.7,
    easting: 329.17,
  },
  {
    md: 1688.59,
    inc: 90,
    azi: 350,
    tvd: 1425.43,
    northing: 222.53,
    easting: 341.18,
  },
  {
    md: 1706.88,
    inc: 90,
    azi: 348.2,
    tvd: 1425.43,
    northing: 234.5,
    easting: 359.14,
  },
  {
    md: 1737.36,
    inc: 90,
    azi: 345.2,
    tvd: 1425.43,
    northing: 255.39,
    easting: 388.79,
  },
  {
    md: 1767.84,
    inc: 90,
    azi: 342.2,
    tvd: 1425.43,
    northing: 277.41,
    easting: 418.05,
  },
  {
    md: 1798.32,
    inc: 90,
    azi: 339.2,
    tvd: 1425.43,
    northing: 300.5,
    easting: 446.81,
  },
  {
    md: 1828.8,
    inc: 90,
    azi: 336.2,
    tvd: 1425.43,
    northing: 324.61,
    easting: 475.01,
  },
  {
    md: 1859.28,
    inc: 90,
    azi: 333.2,
    tvd: 1425.43,
    northing: 349.65,
    easting: 502.56,
  },
  {
    md: 1889.76,
    inc: 90,
    azi: 330.2,
    tvd: 1425.43,
    northing: 375.57,
    easting: 529.39,
  },
  {
    md: 1920.24,
    inc: 90,
    azi: 327.2,
    tvd: 1425.43,
    northing: 402.3,
    easting: 555.43,
  },
  {
    md: 1950.72,
    inc: 90,
    azi: 324.2,
    tvd: 1425.43,
    northing: 429.75,
    easting: 580.61,
  },
  {
    md: 1981.2,
    inc: 90,
    azi: 321.2,
    tvd: 1425.43,
    northing: 457.86,
    easting: 604.85,
  },
  {
    md: 2011.68,
    inc: 90,
    azi: 318.2,
    tvd: 1425.43,
    northing: 486.55,
    easting: 628.1,
  },
  {
    md: 2042.16,
    inc: 90,
    azi: 315.2,
    tvd: 1425.43,
    northing: 515.73,
    easting: 650.28,
  },
  {
    md: 2061.34,
    inc: 90,
    azi: 313.3,
    tvd: 1425.43,
    northing: 534.11,
    easting: 663.51,
  },
  {
    md: 2072.64,
    inc: 90,
    azi: 312.2,
    tvd: 1425.43,
    northing: 545.34,
    easting: 671.33,
  },
  {
    md: 2103.12,
    inc: 90,
    azi: 309.2,
    tvd: 1425.43,
    northing: 575.28,
    easting: 691.2,
  },
  {
    md: 2133.6,
    inc: 90,
    azi: 306.2,
    tvd: 1425.43,
    northing: 605.48,
    easting: 709.84,
  },
  {
    md: 2164.08,
    inc: 90,
    azi: 303.2,
    tvd: 1425.43,
    northing: 635.85,
    easting: 727.19,
  },
  {
    md: 2194.56,
    inc: 90,
    azi: 300.2,
    tvd: 1425.43,
    northing: 666.32,
    easting: 743.2,
  },
  {
    md: 2225.04,
    inc: 90,
    azi: 297.2,
    tvd: 1425.43,
    northing: 696.78,
    easting: 757.84,
  },
  {
    md: 2255.52,
    inc: 90,
    azi: 294.2,
    tvd: 1425.43,
    northing: 727.18,
    easting: 771.06,
  },
  {
    md: 2286,
    inc: 90,
    azi: 291.2,
    tvd: 1425.43,
    northing: 757.41,
    easting: 782.81,
  },
  {
    md: 2316.48,
    inc: 90,
    azi: 288.2,
    tvd: 1425.43,
    northing: 787.4,
    easting: 793.11,
  },
  {
    md: 2346.96,
    inc: 90,
    azi: 285.2,
    tvd: 1425.43,
    northing: 817.05,
    easting: 801.85,
  },
  {
    md: 2377.44,
    inc: 90,
    azi: 282.2,
    tvd: 1425.43,
    northing: 846.32,
    easting: 809.06,
  },
  {
    md: 2407.92,
    inc: 90,
    azi: 279.2,
    tvd: 1425.43,
    northing: 875.09,
    easting: 814.72,
  },
  {
    md: 2433.82,
    inc: 90,
    azi: 276.7,
    tvd: 1425.43,
    northing: 898.95,
    easting: 818.28,
  },
  {
    md: 2438.4,
    inc: 90,
    azi: 276.2,
    tvd: 1425.43,
    northing: 903.29,
    easting: 818.81,
  },
  {
    md: 2468.88,
    inc: 90,
    azi: 273.2,
    tvd: 1425.43,
    northing: 930.86,
    easting: 821.31,
  },
  {
    md: 2499.36,
    inc: 90,
    azi: 270.2,
    tvd: 1425.43,
    northing: 957.7,
    easting: 822.22,
  },
  {
    md: 2529.84,
    inc: 90,
    azi: 267.2,
    tvd: 1425.43,
    northing: 983.75,
    easting: 821.53,
  },
  {
    md: 2560.32,
    inc: 90,
    azi: 264.2,
    tvd: 1425.43,
    northing: 1008.93,
    easting: 819.24,
  },
  {
    md: 2590.8,
    inc: 90,
    azi: 261.2,
    tvd: 1425.43,
    northing: 1033.19,
    easting: 815.37,
  },
  {
    md: 2621.28,
    inc: 90,
    azi: 258.2,
    tvd: 1425.43,
    northing: 1056.44,
    easting: 809.92,
  },
  {
    md: 2651.76,
    inc: 90,
    azi: 255.2,
    tvd: 1425.43,
    northing: 1078.64,
    easting: 802.91,
  },
  {
    md: 2682.24,
    inc: 90,
    azi: 252.2,
    tvd: 1425.43,
    northing: 1099.7,
    easting: 794.35,
  },
  {
    md: 2712.72,
    inc: 90,
    azi: 249.2,
    tvd: 1425.43,
    northing: 1119.59,
    easting: 784.28,
  },
  {
    md: 2743.2,
    inc: 90,
    azi: 246.2,
    tvd: 1425.43,
    northing: 1138.24,
    easting: 772.72,
  },
  {
    md: 2773.68,
    inc: 90,
    azi: 243.2,
    tvd: 1425.43,
    northing: 1155.61,
    easting: 759.69,
  },
  {
    md: 2804.16,
    inc: 90,
    azi: 240.2,
    tvd: 1425.43,
    northing: 1171.64,
    easting: 745.25,
  },
  {
    md: 2806.19,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1172.66,
    easting: 744.23,
  },
  {
    md: 2834.64,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1186.89,
    easting: 730.01,
  },
  {
    md: 2865.12,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1202.15,
    easting: 714.77,
  },
  {
    md: 2895.6,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1217.4,
    easting: 699.53,
  },
  {
    md: 2926.08,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1232.66,
    easting: 684.29,
  },
  {
    md: 2956.56,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1247.92,
    easting: 669.05,
  },
  {
    md: 2987.04,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1263.17,
    easting: 653.81,
  },
  {
    md: 3017.52,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1278.43,
    easting: 638.57,
  },
  {
    md: 3048,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1293.68,
    easting: 623.33,
  },
  {
    md: 3078.48,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1308.94,
    easting: 608.09,
  },
  {
    md: 3108.96,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1324.19,
    easting: 592.85,
  },
  {
    md: 3139.44,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1339.45,
    easting: 577.61,
  },
  {
    md: 3169.92,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1354.7,
    easting: 562.37,
  },
  {
    md: 3200.4,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1369.96,
    easting: 547.13,
  },
  {
    md: 3230.88,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1385.21,
    easting: 531.89,
  },
  {
    md: 3261.36,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1400.47,
    easting: 516.65,
  },
  {
    md: 3291.84,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1415.72,
    easting: 501.41,
  },
  {
    md: 3322.32,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1430.98,
    easting: 486.17,
  },
  {
    md: 3352.8,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1446.23,
    easting: 470.93,
  },
  {
    md: 3383.28,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1461.49,
    easting: 455.69,
  },
  {
    md: 3413.76,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1476.74,
    easting: 440.45,
  },
  {
    md: 3444.24,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1492,
    easting: 425.21,
  },
  {
    md: 3474.72,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1507.25,
    easting: 409.97,
  },
  {
    md: 3505.2,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1522.51,
    easting: 394.73,
  },
  {
    md: 3535.68,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1537.76,
    easting: 379.49,
  },
  {
    md: 3566.16,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1553.02,
    easting: 364.25,
  },
  {
    md: 3596.64,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1568.28,
    easting: 349.01,
  },
  {
    md: 3627.12,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1583.53,
    easting: 333.77,
  },
  {
    md: 3657.6,
    inc: 90,
    azi: 240,
    tvd: 1425.43,
    northing: 1598.79,
    easting: 318.53,
  },
];
